import { searchActions } from '../actions'

const {
  CHANGE_SEARCH_TEXT,
  CLEAR_SEARCH_TEXT
} = searchActions

const initialState = {
  searchText: ''
};

const search = (state = initialState, action = '') => {
  switch (action.type) {
    case CHANGE_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.value
      };
    
    case CLEAR_SEARCH_TEXT:
      return {
        ...state,
        searchText: ''
      };

    default:
      return state;
  }
};

export default search



// WEBPACK FOOTER //
// ./src/reducers/search.js